<template>
  <v-list rounded>
    <v-radio-group v-model="userAnswer">
      <v-list-item-group>
        <template v-for="(item, i) in answers">
          <v-list-item
            :key="`item-${i}`"
            :value="item"
            @click="userAnswer = item.answerId"
          >
            <template v-slot:default="{}">
              <v-list-item-content>
                <v-list-item-title v-text="item.answerText"></v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                <v-radio
                  color="primary accent-4"
                  :value="item.answerId"
                  readonly
                ></v-radio>
              </v-list-item-action>
            </template>
          </v-list-item>
        </template>
      </v-list-item-group>
    </v-radio-group>
  </v-list>
</template>

<script>
import AnswerService from "@/services/AnswerService.js";
import UserAnswerService from "@/services/UserAnswerService.js";

export default {
  name: "UserAnswer",
  props: {
    questionId: String,
    userTestId: String
  },
  data() {
    return {
      answers: [],
      loading: false,
      userAnswer: "",
      existingAnswer: ""
    };
  },
  created() {
    this.getAnswers();
  },
  methods: {
    async getAnswers() {
      this.loading = true;
      try {
        this.answers = await AnswerService.getAnswersByQuestionId(
          this.questionId
        );
      } finally {
        this.loading = false;
      }
    },

    async selected() {
      try {
        this.existingAnswer = await UserAnswerService.getByQuestionId(
          this.questionId,
          this.userTestId
        );
      } catch {
        UserAnswerService.postUserAnswer({
          answerId: this.userAnswer,
          userTestId: this.userTestId
        });
        return;
      }
      this.existingAnswer.answerId = this.userAnswer;
      await UserAnswerService.updateUserAnswer(
        this.existingAnswer.userAnswerId,
        this.userAnswer
      );
    }
  },
  watch: {
    userAnswer() {
      this.selected();
    }
  }
};
</script>

<style scoped></style>
